/* eslint-disable max-len */
import { RootState } from 'interfaces';
import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state['feature/newsfeed'] || initialState;

export const selectNewsfeeds = createSelector([selectDomain], (NewsfeedState) => NewsfeedState.newsfeeds);
export const selectNewsfeedsLoader = createSelector([selectDomain], (NewsfeedState) => NewsfeedState.loading);
export const selectNewsfeedsTotal = createSelector([selectDomain], (NewsfeedState) => NewsfeedState.total);
export const selectNewsfeedFormData = createSelector([selectDomain], (NewsfeedState) => NewsfeedState.newsfeedFormData);
export const selectPinnedNewsfeeds = createSelector([selectDomain], (NewsfeedState) => NewsfeedState.pinnedPosts);
